import "@fontsource-variable/nunito-sans";
import "./index.css";
import "./i18n";

import { RouterProvider } from "react-router";
import { ToastContainer } from "react-toastify";
import router from "./router";
import { AuthProvider } from "./context/auth";
import { LanguageProvider } from "./context/language";
import ReactDOM from "react-dom/client";
import { config, posthogKey } from "./config/posthog";
import CookieBanner from "./molecules/CookieBanner";
import { PostHogProvider } from "posthog-js/react";

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <div className="bg-background flex min-h-screen flex-col">
    <PostHogProvider apiKey={posthogKey} options={config}>
      <LanguageProvider>
        <AuthProvider>
          <RouterProvider router={router} />
          <CookieBanner />
          <ToastContainer
            hideProgressBar={true}
            position="bottom-right"
            stacked
          />
        </AuthProvider>
      </LanguageProvider>
    </PostHogProvider>
  </div>,
);
